/**
 * PlanChip — an extremely lightweight, account-info-style plan indicator for
 * the dashboard sidebar / drawer footer. Shown ONLY to Free Weekly users
 * (PERSONAL_WEEKLY_FREE, non-admin). Behaves like account information, not
 * advertising: no badges, no countdowns, no "Upgrade Now!" — just the current
 * plan and a quiet "View plans" link to /dashboard/plan.
 */
import { Link } from 'react-router-dom';
import { useEntitlements } from '@/lib/entitlements';
import { useLanguage } from '@/lib/i18n';

export default function PlanChip({ className = '' }) {
  const ent = useEntitlements();
  const { lang } = useLanguage();
  const ja = lang === 'ja';

  if (!ent.ready || ent.is_admin || ent.plan_group !== 'PERSONAL_WEEKLY_FREE') return null;

  return (
    <Link
      to="/dashboard/plan"
      data-testid="plan-chip"
      className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg border border-slate-200 bg-slate-50/70 hover:bg-slate-100 transition-colors ${className}`}
    >
      <span className="flex flex-col leading-tight min-w-0">
        <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-slate-400">
          {ja ? '現在のプラン' : 'Current Plan'}
        </span>
        <span className="text-[12px] font-bold text-slate-700 truncate">
          {ja ? '無料週次プラン' : 'Free Weekly'}
        </span>
      </span>
      <span className="text-[11px] font-bold text-[#9200C7] whitespace-nowrap">
        {ja ? 'プランを見る →' : 'View plans →'}
      </span>
    </Link>
  );
}
